











































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {Lading} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {ManageFeeStore} from "@/modules/managefeecustomer/store";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Số Bill",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: "ladingCode"}
    },
    {
        title: "Ngày phát hành",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 150,
        ellipsis: true
    },
    {
        title: "Tỉnh đến",
        dataIndex: "locationTo.province.name",
        key: "provinceTo",
        width: 180,
        ellipsis: true
    },
    {
        title: "DV",
        dataIndex: "freightService.name",
        key: "freightService",
        width: 180,
        ellipsis: true
    },
    {
        title: "TL(g)",
        dataIndex: "weight",
        key: "weight",
        width: 180,
        ellipsis: true,
        scopedSlots: { customRender: 'weight' }
    },
    {
        title: "Cước chính",
        dataIndex: "mainFee",
        key: "mainFee",
        scopedSlots: {customRender: 'mainFee'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Cước GTGT",
        dataIndex: "vasFee",
        key: "vasFee",
        scopedSlots: {customRender: 'vasFee'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Cước cộng thêm",
        dataIndex: "feeExtra",
        key: "feeExtra",
        scopedSlots: {customRender: 'feeExtra'},
        width: 150,
        ellipsis: true
    },
    {
        title: "PPNL",
        dataIndex: "fuelFee",
        key: "fuelFee",
        scopedSlots: {customRender: 'fuelFee'},
        width: 150,
        ellipsis: true
    },
    {
        title: "PPVX",
        dataIndex: "regionFarFee",
        key: "regionFarFee",
        scopedSlots: {customRender: 'regionFarFee'},
        width: 150,
        ellipsis: true
    },
    {
       title: "Tổng cước",
       dataIndex: "rowGuid",
       key: "totalFee",
       scopedSlots: {customRender: 'totalFee'},
        width: 150,
    },
    {
        title: "VAT",
        dataIndex: "rowGuid",
        key: "vat",
        scopedSlots: {customRender: 'vat'},
        width: 150,
    },
    {
        title: "Thành tiền",
        dataIndex: "rowGuid",
        key: "totalMoney",
        scopedSlots: {customRender: 'totalMoney'},
        width: 150,
    },
];
@Component({
    name: "ManageFeeNotYetPayCustomerTable",
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = columns;

    get billLadings() {
        return ManageFeeStore.notPayIds.map(id => ManageFeeStore.notPayData[id]);
    }

    get pagination() {
        return {
            current: ManageFeeStore.notPayMeta.page,
            pageSize: ManageFeeStore.notPayMeta.limit,
            total: ManageFeeStore.notPayMeta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        const params = {
            ...ManageFeeStore.notPayParams,
            page: pagination.current,
            limit: pagination.pageSize
        }
        ManageFeeStore.paramNotPayManageFeeChange(params);
    }
}
